import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const request = axios.create({
  baseURL: '', // api 的 base_url
  timeout: 5000 // 请求超时时间
});

// response 拦截器
request.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 0) {
      // Message({
      //   message: res.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // });
      return res;
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error); // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error)
  }
);

export function getClientNewestVersion() {
  return request({
    url: '/api_ext/ovpn/newest_client',
    method: 'get'
  })
}

export function checkIsInnerIp() {
  return request({
    url: '/api_ext/ovpn/oversea/check_inner_net',
    method: 'get'
  })
}

export function postBrowserAgent(agent, platform) {
  return request({
    url: '/api_ext/monitor/browser_agent',
    method: 'post',
    data: {agent: agent, platform: platform}
  })
}



// WEBPACK FOOTER //
// ./src/api.js